/// <amd-module name="typeahead/core/IOverrideParams" />
export interface IOverrideParams {
    featureOverrides: any;
}
